import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { take } from 'rxjs';
import { PersonalDataComponent } from './components/personal-data/personal-data.component';
import { SecurityComponent } from './components/security/security.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { TabPermissionService } from 'app/core/auth/tab-permission.service';

export interface AccountSettingsMenuItem {
    id: string;
    title: string;
    icon: string;
    active?: boolean;
    route?: string;
}

@Component({
    selector: 'account-settings-modal',
    templateUrl: './account-settings-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        PersonalDataComponent,
        SecurityComponent,
        NotificationsComponent
    ]
})
export class AccountSettingsModalComponent implements OnInit {
    menuItems: AccountSettingsMenuItem[] = [
        {
            id: 'personal-data',
            title: 'Meus dados',
            icon: 'mat_outline:person',
            active: true
        },
        {
            id: 'security',
            title: 'Segurança',
            icon: 'mat_outline:security'
        },
        {
            id: 'notifications',
            title: 'Notificações',
            icon: 'mat_outline:notifications'
        },
        // {
        //     id: 'preferences',
        //     title: 'Preferências',
        //     icon: 'mat_outline:settings'
        // }
    ];

    /**
     * Entradas de ADMINISTRAÇÃO (Trilha de Auditoria) — decisão do usuário:
     * a Trilha de Auditoria fica DENTRO deste modal e a sidebar perde o item
     * (data-driven). "Saúde do Sistema" virou item de menu visível na sidebar
     * (`/health`, screen_key `aud-access`) e por isso SAIU deste bloco.
     * Visíveis apenas com `aud-access`.
     */
    adminMenuItems: AccountSettingsMenuItem[] = [
        {
            id: 'audit-trail',
            title: 'Trilha de Auditoria',
            icon: 'heroicons_outline:clipboard-document-list',
            route: '/config/audit'
        }
    ];

    canAccessAdministration: boolean = false;

    selectedMenuItem: string = 'personal-data';
    isMenuOpen: boolean = true;
    window = window;

    constructor(
        public dialogRef: MatDialogRef<AccountSettingsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _router: Router,
        private _tabPermission: TabPermissionService
    ) {
        // Inicia com menu fechado em telas pequenas (abaixo de it: 600px)
        if (window.innerWidth < 600) {
            this.isMenuOpen = false;
        }
    }

    ngOnInit(): void {
        // Decide a visibilidade da seção "Administração" pela screen_key
        // `aud-access` (cache da sessão; revalidação defensiva e barata).
        if (this._tabPermission.loaded) {
            this.canAccessAdministration = this._tabPermission.canAccess('aud-access');
        }

        this._tabPermission.loadPermissions()
            .pipe(take(1))
            .subscribe(() => {
                this.canAccessAdministration = this._tabPermission.canAccess('aud-access');
            });
    }

    selectMenuItem(itemId: string): void {
        this.menuItems.forEach(item => item.active = item.id === itemId);
        this.selectedMenuItem = itemId;

        // Fecha o menu em telas pequenas após selecionar um item (abaixo de it: 600px)
        if (window.innerWidth < 600) {
            this.isMenuOpen = false;
        }
    }

    /** Fecha o modal e navega para a tela de administração escolhida. */
    openAdminRoute(route: string): void {
        this.dialogRef.close();
        this._router.navigate([route]);
    }

    toggleMenu(): void {
        this.isMenuOpen = !this.isMenuOpen;
    }

    getMenuItemTitle(itemId: string): string {
        const item = this.menuItems.find(i => i.id === itemId);
        return item ? item.title : '';
    }

    saveSettings(): void {
        // Aqui você implementará a lógica de salvar as configurações
        console.log('Salvando configurações...');
        this.dialogRef.close({ action: 'reload' });
    }

    closeModal(): void {
        this.dialogRef.close();
    }
}
